<template>
  <v-app>
    <v-sheet
      class="d-flex justify-center align-center"
      height="100%"
      width="100%"
      color="transparent"
      v-if="loading"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <template v-else>
      <Header />
      <router-view />
      <Footer />

      <CookieBanner />
    </template>
  </v-app>
</template>

<script>
import Header from "./components/shell/header/Index.vue";
import Footer from "./components/shell/Footer.vue";
import CookieBanner from "./components/widgets/CookieBanner.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      if (!this.$rest(`informations`).item) return "";
      return this.$rest(`informations`).item;
    },
    name() {
      return this.informations.short_name || ``;
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = this.name;
    },
  },
  watch: {
    // $route() {
    //   this.updateDocumentTitle();
    // },
    name() {
      this.updateDocumentTitle();
    },
  },
  mounted() {
    this.$rest(`informations`).get({
      save: (state, data) => (state.item = data),
    });

    this.$rest(`business`).get();

    this.$rest("categories").get({ params: { type: "types" } });

    this.$rest("categories")
      .get({ params: { type: "districts" } })
      .then(() => (this.loading = false));
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    Header,
    Footer,
    CookieBanner,
  },
};
</script>

<style>
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}

.v-btn {
  width: min-content;
}

.filter-white {
  filter: brightness(0) invert(1);
}

.theme--light.v-pagination .v-pagination__item,
.theme--light.v-pagination .v-pagination__navigation {
  height: 50px;
  font-size: 18px;
  width: 50px;
}

.theme--light.v-pagination .v-pagination__navigation .v-icon {
  font-size: 18px;
}
</style>
